import React from 'react';
import { ComboboxOptions } from '@headlessui/react';

import useAppContext from 'flow/hooks/useAppContext';
import { ACCESS_CANDIDATE_PANEL_CLASSES } from './AccessCandidateList';

/**
 * Its own panel because the list is virtualised: the virtualiser renders nothing
 * at all for an empty set, so it has no row to put this in.
 */
const AccessNoCandidates = () => {
    const { i18next } = useAppContext();

    return (
        <ComboboxOptions
            anchor={{ to: 'bottom start', gap: 4 }}
            modal={false}
            className={ACCESS_CANDIDATE_PANEL_CLASSES}
        >
            <div className="px-3 py-2 text-sm text-gray-500">
                {i18next.t('General.Search.Empty.Title')}
            </div>
        </ComboboxOptions>
    );
};

export default AccessNoCandidates;
